import { FC } from 'react';

import { chakra, StyleProps } from '@bonusly/design-system';

import { AnimationStyle } from './animation-style';
import { ReactComponent as Bubbles } from './assets/bubbles.svg';

const StyledBubbles = chakra(Bubbles);

export const AnimatedBubbles: FC<StyleProps> = (props) => {
	return (
		<>
			<AnimationStyle />
			<StyledBubbles {...props} />
		</>
	);
};
